import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/perfil/actions';

import MyForm from './form';

function Perfil() {
  const data = useSelector((state) => state.perfil);

  const optionsStaus = useMemo(
    () => [
      { value: 'Liberado', label: 'Liberado' },
      { value: 'Bloqueado', label: 'Bloqueado' },
      { value: 'Cancelado', label: 'Cancelado' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'perf_descricao',
        label: 'Perfil Nome',
        filter: { type: 'text' },
      },
      {
        id: 'perf_status_string',
        label: 'Perfil Status',
        //converter: optionsStaus,
        //filter: { type: 'select', options: optionsStaus }

        formatted: (value) =>
          optionsStaus.find((option) => option.label === value).value,
        filter: {
          type: 'select',
          options: optionsStaus,
        },
      },
      // {
      //   id: 'perf_status',
      //   label: 'Perfil Status',
      //   converter: optionsStaus,
      //   filter: { type: 'select', options: optionsStaus }
      // }
    ],
    []
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="perf_codigo ASC"
        fixed
        create={true}
        delete={true}
        update={true}
        header={header}
        redux={data}
        //custom={filter}
        //actions={buttons}
        keys={['perf_codigo']}
        detach="perf_descricao"
        read={recordFiltering}
        find={findData}
        remove={deleteData}
        form={MyForm}
        maxWidth="lg"
        //maxHeight="lg"

        query={{
          wherefield: ['perf_padrao', 'perf_tipo'],
          valuewherefield: ['N', '1'],
          typewherefield: ['EQUALS', 'EQUALS'],
        }}
        view="VW_PERFIL"
        reportTitle="Cadastro de Perfil"
      />

      {/* <Tabela
        read={dataInRequest}
        remove={deleteData}
        state={data}
        header={header}
        headerMobile="perf_descricao"
        unique={['perf_codigo']}
        form={MyForm}
        findItem={findData}
        recordFilter={recordFiltering}
        modal="lg"
      /> */}
    </>
  );
}

export default Perfil;
